<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div style="margin-top:15px; margin-bottom:-10px;">
      <h4><span style="padding-right:10px"></span> <i class="fa fa-edit"></i>Carrier Type: <b>{{lblHeading}}</b></h4>
    </div>
  </div>
  <hr />

  <div class="row" style="margin-top:20px;margin-left:0px;margin-right:0px;padding:0px;">
    <div class="col-md-12" style="margin:0px;padding:0px;">
      <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
        <div class="row" style="margin:0px;padding:0px;width:100%">

          <div style="margin:0px;padding:0px;" class="col-md-6">
            <div class="col-md-12" style="margin:0px;padding:0px;">
              <div class="col-sm-12" style="margin:0px;padding:0px;">
                <label class="control-label" style="margin:0px;padding:0px;">
                  <strong>Carrier Type Code<a class="red-asterik">*</a></strong>
                  <span *ngIf="isDup" class="text-danger">Duplicate Codes are not allowed</span>
                </label>
              </div>

              <div class="col-sm-12" style="margin:0px;padding:0px;">
                <input type="text" name="code" formControlName="code" class="form-control" [ngClass]="{'error':form.controls.code.invalid && form.controls.code.dirty, 'noerror': form.controls.code.valid && form.controls.code.dirty}" title="Codes must be unique. Main sort order if group_code and sort_order not used." />
                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.code.invalid && form.controls.code.dirty">
                  <p *ngIf="form.controls.code.errors.required">Code is required</p>
                  <p *ngIf="form.controls.code.errors.maxlength">Code must not be more than 12 characters.</p>
                </div>
              </div>

            </div>
            <div class="col-md-12 no-sp" style="margin:5px auto;padding:0px;">
              <div class="row" style="margin:0px; padding:0px;">
                <!-- <div class="col-6" style="margin:0px;padding:0px;"> -->
                  <div class="col-12" style="margin:0px; padding:0px;">
                    <label class="control-label" for="id_type_required_ind" style="margin:0px;padding:0px;">
                      <strong style="">ID Type Required<a class="red-asterik">*</a>&nbsp; </strong>
                    </label>
                  </div>
                    <div class="col-12" style="width:100%;margin:0px;padding:0px;">
                      <select style="margin:0px;padding:0px;width:100%;" class="form-control" id="id_type_required_ind" [(ngModel)]="selectedDisplay" (change)="onSelectChange()" name="id_type_required_ind" formControlName="id_type_required_ind" style="" title="The type of identification needed for this carrier type.">
                        <option *ngFor="let ind of utility.idTypes" [ngValue]="ind.key">{{ind.value}}</option>
                      </select>
                    </div>
                  <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-md-6" style="margin:0px;padding:0px;">
            <div class="row" style="margin:0px; padding:0px 0px 0px 10px;">
              <!--<div>-->
              <label class="col-12 control-label" style="width:100%;margin:0px;padding:0px;"><strong>Description</strong></label>
              <div class="col-12" style="width:100%;margin:0px;padding:0px;">
                <textarea class="col-12" style="height: 100px;width:100%;" name="description" formControlName="description" class="form-control" [ngClass]="{'error':form.controls.description.invalid && form.controls.description.dirty, 'noerror': form.controls.description.valid && form.controls.description.dirty}" title="Free text description of the entity occurrence."></textarea>
                <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.description.invalid && form.controls.description.dirty">
                  <p *ngIf="form.controls.description.errors.required">Description is required</p>
                  <p *ngIf="form.controls.description.errors.maxlength">Description must not be more than 100 characters</p>
                </div>
                <!--</div>-->
              </div>
            </div>
          </div>

          <div class="col-md-12" style="margin:5px 0px;padding:0px;">
         
          </div>

          <div class="col-12" style="margin:8px auto;padding:0px;">
            <div class="row" style="margin:0px;padding:0px;">
              <div class="form-inline col-3" style="margin:0px;padding:0px;">
                <div class="form-check form-check-inline" style="margin:0px!important;">
                  <label><strong style="margin-right:5px;">Local Carrier<a class="red-asterik">*</a> </strong></label>
                  <input class="form-control input-sm" type="checkbox" id="is_local_carrier" formControlName="is_local_carrier" title="Indicates if the entity is an locally registered carrier.">
                </div>
              </div>
              <div class="form-inline col-3">
                <div class="form-check form-check-inline" style="margin:0px!important;">
                  <label><strong style="margin-right:5px;">Is Type an Individual?<a class="red-asterik">*</a> </strong></label>
                  <input class="form-control input-sm" type="checkbox" id="is_individual" formControlName="is_individual" title="Indicates if the entity or type is an individual.">
                </div>
              </div>
              <div class="form-inline col-3">
                <div class="form-check form-check-inline" style="margin:0px!important;">
                  <label><strong style="margin-right:5px;">Is Type an NPO?<a class="red-asterik">*</a> </strong></label>
                  <input class="form-control input-sm" type="checkbox" id="is_npo" formControlName="is_NPO" title="Indicates if the entity or type is NPO.">
                </div>
              </div>
              <div class="form-inline col-3" >
                <div class="form-check form-check-inline" style="margin:0px;padding:0px;">
                  <label><strong style="margin-right:5px;">Display Demographic Frame<a class="red-asterik">*</a> </strong></label>
                  <input class="form-control input-sm" type="checkbox" id="display_demog_frame" formControlName="display_demog_frame" title="Indicates whether the BBBEE-related demographic frame should be displayed for this carrier type.">
                </div>
              </div>          
            </div>
          </div>

          <br/>
          <br/>

          <br/>
        
          <!-- Sorting and Displaying -->
          <div class="col-12">
            <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
              <legend class="scheduler-border tsk-display blackcontrol">Sorting And Displaying</legend> 
              <div class="col-md-12 no-sp" style="margin:5px auto;padding:0px;">
                <div class="row">
                  <div class="col-md-3">
                    <label class="control-label col-md-12" style="margin:0px;padding:0px;">
                      <strong class="" style="width:110px;">Sort Order<a class="red-asterik">*</a>&nbsp; </strong>
                    </label>
                    <div class="col-md-12" style="margin:0px;padding:0px;">
                      <select id="sort_order" class="form-control" name="sort_order" formControlName="sort_order" style="width:100%;" title="Allows user to put in a sorting code. By default, all rows will have sort_order 1.">
                        <option *ngFor="let rank of utility.sortOrderList" [ngValue]="rank" [selected]="0">{{rank}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="control-label col-md-12" style="margin:0px;padding:0px;">
                      <strong>Group<a class="red-asterik">*</a>&nbsp; </strong>
                    </label>
                    <div class="col-md-12" style="margin:0px;padding:0px;">
                      <input type="text" class="form-control" name="group_code" formControlName="group_code" style="width:150px;" [ngClass]="{'error':form.controls.group_code.invalid && form.controls.group_code.dirty, 'noerror': form.controls.group_code.valid && form.controls.group_code.dirty}" title="Allows user to group codes. By default, all rows will belong to group A.">
                      <div class="form-control-feedback text-danger text-small" *ngIf="form.controls.group_code.invalid && form.controls.group_code.dirty">
                        <p *ngIf="form.controls.group_code.errors.required">Group Code is required</p>
                        <p *ngIf="form.controls.group_code.errors.maxlength">Group Code must not be more than 12 characters.</p>
                      </div>
                    </div>
  
                  </div>
                  <div class="col-md-3">
                    <label class="control-label col-md-12" style="margin:0px;padding:0px;">
                      <strong style="">Display ?<a class="red-asterik">*</a>&nbsp; </strong>
                    </label>
                    <div class="col-md-12" style="margin:0px;padding:0px;">
                      <select class="form-control" id="display_ind" [(ngModel)]="selectedDisplay" (change)="onSelectChange()" name="display_ind" formControlName="display_ind" style="width:80%;" title="Indicates where it is used on dropdowns or lists.">
                        <option *ngFor="let ind of utility.displayIndicators" [ngValue]="ind.key">{{ind.value}}</option>
                      </select>
                    </div>
                  </div>
  
                  <div class="col-md-3">

                    <div class="form-check form-check-inline">
                      <br/>
                      <br/>
                      <label><strong style="">Active?&nbsp; </strong></label>
                      <input class="form-control input-sm" type="checkbox" id="is_active" formControlName="is_active" title="An indicator to control if the row will appear on a list or in a search. Can be used to indicate logically deleted.">
                    </div>
                  </div>
                </div>
              </div> 
            </fieldset>
          </div>
          <!-- End of Sorting and Displayings -->

            <div class="col-12" style="margin:10px 0;padding:20px 0; font-size:11px;">
              <dl style="width:460px;margin:0px;padding:0px;">
                <dt style="width:40px;">Created</dt>
                <dd [innerHTML]="audit.created"></dd>
                <dt style="width:46px;">Updated</dt>
                <dd [innerHTML]="audit.updated"></dd>
              </dl>
            </div>
        </div>
        <!-- End -->

        <hr>
        <div class="col-md-12">
          <br>
          <button class="main-btn rounded-circle rmp-all" title="Run task.."   title="Save change(s)" type="submit" id="btnSave" 
            style="margin: 0px auto!important; float: right; padding-top: 3px;" rel="tooltip" data-placement="top">
            <span class="fa fa-save" style="margin:5.5px auto;color:white!important;"
              aria-hidden="true"></span>
           </button>
           <div class="main-btn rounded-circle rmp-all" title="Run task.." title="Go Back" id="btnCancel" [routerLink]="['/carrier/type/list']" 
           style="margin-right:10px !important; float: right; padding-top: 3px;" rel="tooltip" data-placement="top">
           <span class="fa fa-arrow-circle-left" style="margin:5.5px auto;color:white!important;"
             aria-hidden="true"></span>
        </div>
        </div>
      </form>
    </div>
  </div>
</div> <!--End Container -->
